import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown, User } from 'lucide-react';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navGroups = [{
    name: 'The Club',
    links: [{
      name: 'About',
      path: '/about'
    }, {
      name: 'Gallery',
      path: '/gallery'
    }]
  }, {
    name: 'Experiences',
    links: [{
      name: 'Facilities',
      path: '/facilities'
    }, {
      name: 'Dining',
      path: '/dining'
    }, {
      name: 'Sports',
      path: '/sports'
    }]
  }, {
    name: 'Events & Stays',
    links: [{
      name: 'Banquets',
      path: '/banquets'
    }, {
      name: 'Accommodation',
      path: '/accommodation'
    }, {
      name: 'Events',
      path: '/events'
    }]
  }, {
    name: 'Members',
    links: [{
      name: 'Member Services',
      path: '/members'
    }, {
      name: 'Information to Members',
      path: '/members/information'
    }, {
      name: 'Affiliated Clubs',
      path: '/affiliated-clubs'
    }, {
      name: 'Committee',
      path: '/committee'
    }, {
      name: 'Member Login',
      path: '/members/login'
    }]
  }, {
    name: 'Contact',
    links: [{
      name: 'Contact & Enquiries',
      path: '/contact'
    }, {
      name: 'Policies',
      path: '/policies'
    }]
  }];
  const isActive = (path: string) => location.pathname.startsWith(path);
  const isGroupActive = (links: {
    path: string;
  }[]) => links.some(link => isActive(link.path));
  return <header className="sticky top-0 z-50 w-full bg-club-canvas/95 backdrop-blur-sm border-b border-club-border" data-id="element-210">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-211">
        <div className="flex justify-between items-center h-20" data-id="element-212">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-213">
            <Link to="/" className="flex items-center gap-2.5" data-id="element-214">
              <span className="font-serif text-2xl text-club-green font-semibold tracking-wide leading-none" data-id="element-215">
                ASCA
              </span>
              <span className="hidden sm:block h-7 w-px bg-club-border" data-id="element-216" />
              <span className="hidden sm:block text-[0.6rem] leading-tight tracking-[0.15em] text-club-ink/60 uppercase max-w-[9rem]" data-id="element-217">
                Andhra Social &amp; Cultural Association
              </span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex space-x-8" data-id="element-218">
            {navGroups.map(group => <div key={group.name} className="relative group h-20 flex items-center" data-id="element-219">
                <button className={`inline-flex items-center px-1 pt-1 text-sm font-medium transition-colors ${isGroupActive(group.links) ? 'text-club-green border-b-2 border-club-gold' : 'text-club-ink/80 hover:text-club-green'}`} data-id="element-220">
                  {group.name}
                  <ChevronDown size={14} className="ml-1 opacity-50 group-hover:rotate-180 transition-transform duration-200" data-id="element-221" />
                </button>

                {/* Dropdown */}
                <div className="absolute top-20 left-1/2 -translate-x-1/2 w-56 bg-white border border-club-border shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 transform origin-top translate-y-2 group-hover:translate-y-0" data-id="element-222">
                  <div className="py-2" data-id="element-223">
                    {group.links.map(link => <Link key={link.name} to={link.path} className={`block px-4 py-2 text-sm ${isActive(link.path) ? 'text-club-gold bg-club-canvasAlt' : 'text-club-ink/80 hover:bg-club-canvasAlt hover:text-club-green'}`} data-id="element-224">
                        {link.name}
                      </Link>)}
                  </div>
                </div>
              </div>)}
          </nav>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center space-x-4" data-id="element-225">
            <Link to="/contact" className="text-sm font-medium text-club-ink/80 hover:text-club-green transition-colors" data-id="element-226">
              Enquire
            </Link>
            <Link to="/members/login" className="btn-primary py-2 px-4 text-sm flex items-center gap-2" data-id="element-227">
              <User size={16} data-id="element-228" />
              Member Login
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center lg:hidden" data-id="element-229">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-club-ink hover:text-club-green hover:bg-club-canvasAlt focus:outline-none" data-id="element-230">
              <span className="sr-only" data-id="element-231">Open main menu</span>
              {isMobileMenuOpen ? <X size={24} data-id="element-232" /> : <Menu size={24} data-id="element-233" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="lg:hidden bg-club-canvas border-b border-club-border" data-id="element-234">
          <div className="pt-2 pb-3 space-y-1 h-[calc(100vh-80px)] overflow-y-auto" data-id="element-235">
            {navGroups.map(group => <div key={group.name} className="mb-4" data-id="element-236">
                <div className="px-4 py-2 text-xs font-semibold text-club-gold uppercase tracking-wider" data-id="element-237">
                  {group.name}
                </div>
                {group.links.map(link => <Link key={link.name} to={link.path} className={`block pl-8 pr-4 py-2 border-l-4 text-base font-medium ${isActive(link.path) ? 'bg-club-canvasAlt border-club-gold text-club-green' : 'border-transparent text-club-ink/80 hover:bg-club-canvasAlt hover:border-club-border hover:text-club-green'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-238">
                    {link.name}
                  </Link>)}
              </div>)}
            <div className="mt-4 pt-4 pb-8 border-t border-club-border px-4 space-y-4" data-id="element-239">
              <Link to="/contact" className="block w-full text-center btn-secondary py-3" onClick={() => setIsMobileMenuOpen(false)} data-id="element-240">
                Enquire
              </Link>
              <Link to="/members/login" className="block w-full text-center btn-primary py-3 flex justify-center items-center gap-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-241">
                <User size={16} data-id="element-242" />
                Member Login
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}